import React from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Users from './Users';
import Teams from './Teams';
import FilterData from './FilterData';
import AddNewTeam from './AddNewTeam';
import AddNewUser from './AddNewUser';
import UserDetails from './UserDetails';
import TeamDetails from './TeamDetails';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    'aria-controls': `full-width-tabpanel-${index}`,
  };
}

//Start Css code ...
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
    width: '100%',
    padding: '0px',
    '& .Mui-selected': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
    '& .MuiTabs-root': {
      minHeight: '35px',
    },
    '& .MuiTabs-flexContainer': {
      display: 'inline-block',
    },
    '& .MuiTabs-indicator': {
      backgroundColor: 'transparent !important',
    },
    '& .MuiTab-root': {
      minWidth: '150px',
    },
    '& .PrivateTabIndicator-colorPrimary-14': {
      backgroundColor: '#24618E',
    },
    '& .MuiAppBar-colorDefault': {
      boxShadow: 'none',
      background: '#fff',
      '& .MuiButtonBase-root': {
        border: '1px solid #24618E',
        borderRadius: '6px 6px 0px 0px',
        minHeight: 'auto',
        borderBottom: 'none',
        color: "#333",
        padding: '5px 10px',
      }
    },
    '& h5': {
      margin: '0px',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '16pt',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '30pt',
      },
    }
  },
  mainBlock: {
    padding: '10px',
    position: 'absolute',    
    width: '100%',
    float: 'left',
    background: '#fff',
    top: '2%',
    zIndex: '1',
    width: '100%',
    '& h4': {
      margin: '0',
      color: '#24618E',
      marginTop: '30px',
      '@media only screen and (max-width: 3500px)': {
        fontSize: '20pt',
      },
      '@media only screen and (min-width: 3501px)': {
        fontSize: '30pt',
      },
    },
    '& .MuiPaper-elevation2': {
      boxShadow: 'none',
    },
    '& .focus': {
      background: '#24618E',
      color: "#fff !important",
      fontWeight: '600',
    },
  },
  tabblock: {
    border: '1px solid #24618E',
    paddingTop: '10px',
    borderRadius: '0px 5px 5px 5px',
    marginBottom: '5px',
    paddingBottom: '10px',
    width: '100%',
    float: 'left',
    '& .MuiBox-root': {
      padding: '0px 10px 10px 10px',
    },
    '& .MuiInput-underline:after': {
      borderBottom: 'none !important',
    },
    '& .MuiInput-underline:before': {
      borderBottom: 'none !important',
    }
  },
  nonTab: {
    display: 'none',
  },
  innerTabDiv: {
    width: '100%',
    float: 'left',  
    overflowX: 'hidden',
    overflowY: 'scroll',
  },
  innerTabDivSecond: {
    width: '100%',
    float: 'left',   
    overflowX: 'hidden',
    overflowY: 'auto',
  }
}));
//End Css code ...

//Start UserManagement component code ....
export default function UserManagement() {
  let umHeight = window.innerHeight;
  sessionStorage.setItem('umTabHeight', window.innerHeight);
  sessionStorage.setItem('umTabWidth', window.innerWidth);

  // This code is use to get window viewport height
  if (window.screen.width >= 100 && window.screen.width <= 1500) {
    umHeight = window.innerHeight - 200;
  }
  else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
    umHeight = window.innerHeight - 210;
  }
  else if (window.screen.width >= 3501) {
    umHeight = window.innerHeight - 280;
  }
  else {
    umHeight = window.innerHeight - 200;
  }
  // This code is use to get window viewport height
  const classes = useStyles();
  const theme = useTheme();
  const [value, setValue] = React.useState(0);
  const [usTab, setUsTab] = React.useState("fo");
  const [teTab, setTeTab] = React.useState("fo");
  const [screenUMHeight, setScreenUMHeight] = React.useState(umHeight);

  window.onresize = function () {
    sessionStorage.setItem('umTabHeight', window.innerHeight);
    sessionStorage.setItem('umTabWidth', window.innerWidth);

    if (window.screen.width >= 100 && window.screen.width <= 1500) {
      umHeight = window.innerHeight - 200;
      setScreenUMHeight(umHeight);
    }
    else if (window.screen.width >= 1501 && window.screen.width <= 3500) {
      umHeight = window.innerHeight - 210;
      setScreenUMHeight(umHeight);
    }
    else if (window.screen.width >= 3501) {
      umHeight = window.innerHeight - 280;
      setScreenUMHeight(umHeight);
    }
    else {
      umHeight = window.innerHeight - 200;
      setScreenUMHeight(umHeight);
    }
  };
  // This code is use to change window viewport height


  let userTabb = document.getElementById("user_tab");
  let teamTabb = document.getElementById("team_tab");
  let teamTab;
  let userTab;

  React.useEffect(
    () => {
      let activeTab = sessionStorage.getItem('userActiveTab') ? parseInt(sessionStorage.getItem('userActiveTab')) : 0;
      if (activeTab !== 0) {
        if (activeTab === 1) {
          setValue(1);
          setUsTab("unFocus");
          setTeTab("focus");
        } else if (activeTab === 2) {
          setValue(2);
          setUsTab("focus");
          setTeTab("unFocus");
        } else if (activeTab === 3) {
          setValue(3);
          setUsTab("unFocus");
          setTeTab("focus");
        } else if (activeTab === 4) {
          setValue(4);
          setUsTab("focus");
          setTeTab("unFocus");
        } else if (activeTab === 5) {
          setValue(5);
          setUsTab("unFocus");
          setTeTab("focus");
        }
      }

      return () => {
        if (sessionStorage.getItem('userActiveTab')) {
          sessionStorage.removeItem('userActiveTab')
        }
      };
    }, []
  );

  const handleChange = (event, newValue) => {
    sessionStorage.setItem('userActiveTab', newValue);
    setValue(newValue);
    if (newValue == 0) {
      setUsTab("focus");
      setTeTab("unFocus");
    }
    if (newValue == 1) {
      setUsTab("unFocus");
      setTeTab("focus");
    }
  };

  const handleChangeIndex = (index) => {
    sessionStorage.setItem('userActiveTab', index);
    setValue(index);
    if (index == 0) {
      setUsTab("focus");
      setTeTab("unFocus");
    }
    if (index == 1) {
      setUsTab("unFocus");
      setTeTab("focus");
    }
  };

  const addNewUser = () => {
    sessionStorage.setItem('userActiveTab', 2);
    setValue(2);
    setUsTab("focus");
    setTeTab("unFocus");
  }
  const addNewTeam = () => {
    sessionStorage.setItem('userActiveTab', 3);
    setValue(3);
    setUsTab("unFocus");
    setTeTab("focus");
  }
  const updateUserDetails = (id) => {
    sessionStorage.setItem('userActiveTab', 4);
    sessionStorage.setItem('viewUserId', id);
    setValue(4);
    setUsTab("focus");
    setTeTab("unFocus");
  }
  const updateTeam = teamId => {
    sessionStorage.setItem('userActiveTab', 5);
    sessionStorage.setItem('teamId', teamId);
    setValue(5);
    setUsTab("unFocus");
    setTeTab("focus");
  }

  const backUserList = () => {
    sessionStorage.setItem('userActiveTab', 0);
    setValue(0);
  }
  const backTeamList = () => {
    sessionStorage.setItem('userActiveTab', 1);
    setValue(1);
  }

  return (
    <React.Fragment>
      <div className={classes.mainBlock}>
        <h4>User Management</h4>
        <hr style={{ marginTop: '0px' }} />
        <div className={classes.root}>
          <AppBar position="static" color="default">
            <Tabs
              value={value}
              onChange={handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              <Tab label="Users" {...a11yProps(0)} id="userTabb" data-testid="userListTab" className={usTab} />
              <Tab label="Teams" {...a11yProps(1)} id="team_tab" data-testid="teamListTab" className={teTab} />
              <Tab {...a11yProps(2)} className={classes.nonTab} />
              <Tab {...a11yProps(3)} className={classes.nonTab} />
              <Tab {...a11yProps(4)} className={classes.nonTab} />
              <Tab {...a11yProps(5)} className={classes.nonTab} />
              {/* <Tab label="Add New Users" {...a11yProps(2)} />           */}
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
            index={value}
            onChangeIndex={handleChangeIndex}
          >
            <TabPanel value={value} index={0} dir={theme.direction} className={classes.tabblock}>
              <div className={classes.innerTabDiv} style={{ height: screenUMHeight.toString() + 'px' }}>
                <Users usertab={addNewUser} userDetailstab={updateUserDetails} />
              </div>
            </TabPanel>
            <TabPanel value={value} index={1} dir={theme.direction} className={classes.tabblock}>
              <div className={classes.innerTabDivSecond} style={{ height: screenUMHeight.toString() + 'px' }}>
                <Teams teamtab={addNewTeam} teamDetailstab={updateTeam} />
              </div>
            </TabPanel>
            <TabPanel value={value} index={2} dir={theme.direction} className={classes.tabblock}>
              <div className={classes.innerTabDivSecond} style={{ height: screenUMHeight.toString() + 'px' }}>
                <AddNewUser usertabBack={backUserList} />
              </div>
            </TabPanel>
            <TabPanel value={value} index={3} dir={theme.direction} className={classes.tabblock}>
              <div className={classes.innerTabDivSecond} style={{ height: screenUMHeight.toString() + 'px' }}>
                <AddNewTeam teamTabBack={backTeamList} />
              </div>
            </TabPanel>
            <TabPanel value={value} index={4} dir={theme.direction} className={classes.tabblock}>
              <div className={classes.innerTabDivSecond} style={{ height: screenUMHeight.toString() + 'px' }}>
                <UserDetails usertabBack={backUserList} />
              </div>
            </TabPanel>
            <TabPanel value={value} index={5} dir={theme.direction} className={classes.tabblock}>
              <div className={classes.innerTabDivSecond} style={{ height: screenUMHeight.toString() + 'px' }}>
                <TeamDetails teamTabBack={backTeamList} />
              </div>
            </TabPanel>
          </SwipeableViews>
        </div>
      </div>
    </React.Fragment>
  );
}
//End UserManagement component code ....